<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: zh
 * @Date: 2021-10-09 18:27:08
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-10-26 14:06:44
-->
<template>
  <div class="container">
    <div class="bgoverlay">
      <div class="bg" :style="{'background-image': `url(${require('@/assets/images/servicesbg6.jpg')})`}"></div>
    </div>
    <div class="inner-pannel">
      <div class="pannel-content">
        <div class="pannel-content-box maxwidth-lg topPoint">
          <div class="content-page">
            <div class="ani animate__animated animate__fadeInUp">
                <div style="height:50px"></div>
                <div :class="$i18n.locale=='zh'?'zh-font':'en-font'">{{$t('supplyChain.content1')}}</div>
                <div style="height:20px"></div>
                <div :class="$i18n.locale=='zh'?'zh-font':'en-font'">{{$t('supplyChain.content2')}}</div>
                <div style="height:20px"></div>
                <div :class="$i18n.locale=='zh'?'zh-font':'en-font'">{{$t('supplyChain.content3')}}</div>
                <div style="height:20px"></div>
                <p class="link" style="color: #ed6d00" @click="goTo('5-1')">{{$t('services.function[4].subName[0]')}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default({
  data() {
    return {

    }
  },
  methods: {
    goTo(path) {
      // this.$router.push({path:'/services/supplyChain',query: { index: path}})
      this.$emit('goToDetail', path)
    }
  }
})
</script>

<style scoped>
    .flex{
      display: flex;
    }
    .inner-pannel{
      min-height: 100%;
      padding-bottom: 54px;
      position: static;
      /* position: relative; */
      /* position: absolute; */
      width: 100%;
      font-family: 'Lato';
    }
    .item{
        /* width: 20%; */
        margin-right: 50px;
        text-align: center;
    }
    .year{
        font-size: 40px;
        min-height: 53px;
    }
    .topPoint::after {
        width: 25px;
        height: 25px;
        content: "";
        position: absolute;
        background: #ed6d00;
        border-radius: 50%;
        z-index: 1;
        top: -12.5px;
        right: -12.5px;
    }
  .right-color{
    color: #ed6d00;
  }
  .link{
    cursor:pointer;
    font-family: 'Lato','Microsoft JhengHei';
  }
</style>



// WEBPACK FOOTER //
// src/components/supplyChain/supplyChain.vue